import { render, staticRenderFns } from "./ServerSentEventsTest.vue?vue&type=template&id=77333a66"
import script from "./ServerSentEventsTest.vue?vue&type=script&lang=js"
export * from "./ServerSentEventsTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports